import { render, staticRenderFns } from "./dashboardRequisitosCursos.vue?vue&type=template&id=ac0dcfe8&"
import script from "./dashboardRequisitosCursos.vue?vue&type=script&lang=js&"
export * from "./dashboardRequisitosCursos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports